module.exports = __webpack_public_path__ + "static/media/worldieAlert.1d5c0851.svg";